export const GET_PMS_DIT_SALES_OVERVIEW_YTD = 'GET_PMS_DIT_SALES_OVERVIEW_YTD';
export const GET_PMS_DIT_SALES_OVERVIEW_YTD_SUCCESS = 'GET_PMS_DIT_SALES_OVERVIEW_YTD_SUCCESS';
export const GET_PMS_DIT_SALES_OVERVIEW_YTD_FAILURE = 'GET_PMS_DIT_SALES_OVERVIEW_YTD_FAILURE';

